"use strict";

/**
 * @classdesc
 * Implementierung einer Factory zur Erzeugung von Feature-Service-Implementierungen.
 *
 * @class
 * @memberof gc.gis.factory
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {gc.gis.util.GCRequestManager} requestManager Objekt zur Ausführung von Requests
 * @param {Object<string,string>} requests Service-URLs
 * @param {string} requests.identifyUrl Service-URL zum Identifizieren von Objekten
 * @param {string} requests.identifyDetailUrl Service-URL zum Abfragen von Detailinformationen zu einem Objekt
 * @param {string} requests.queryMapFeatureUrl Service-URL zum Abfragen von Objekten zur aktuellen Kartenansicht
 * @param {string} requests.layerTooltipUrl Service-URL zum Abfragen von HTML-Popups
 * @param {string} requests.addFeatureUrl Service-URL zum Anlegen neuer Objekte
 * @param {string} requests.updateFeatureUrl Service-URL zum Aktualisieren von Objekten
 * @param {string} requests.deleteFeatureUrl Service-URL zum Löschen von Objekten
 */
gc.gis.factory.ServiceFactory = function(requestManager, requests)
{
	/**
	 * @type {gc.gis.util.GCRequestManager}
	 * @private
	 */
	this._requestManager = requestManager;
	/**
	 * @type {Object}
	 * @private
	 */
	this._requests = requests;
};

/**
 * Erzeugt einen Service zum Zugriff auf Features, welche über die Serverkomponente verfügbar sind.
 *
 * @return {gc.gis.service.QueryFeatureService}
 */
gc.gis.factory.ServiceFactory.prototype.createQueryService = function ()
{
	return new gc.gis.service.QueryFeatureService(
		this._requestManager,
		this._requests.identifyUrl,
		this._requests.identifyDetailUrl,
		this._requests.queryMapFeatureUrl
	);
};

/**
 * Erzeugt einen Service zum Zugriff auf HtmlPopups der Features, welche über die Serverkomponente verfügbar sind.
 *
 * @return {gc.gis.service.HtmlPopupService}
 */
gc.gis.factory.ServiceFactory.prototype.createHtmlPopupService = function ()
{
	return new gc.gis.service.HtmlPopupService(
		this._requestManager,
		this._requests.layerTooltipUrl
	);
};

/**
 * Erzeugt einen Transaktions-Service zum Zugriff auf Features, welche über die Serverkomponente verfügbar sind.
 *
 * @return {gc.gis.service.TransactionFeatureService}
 */
gc.gis.factory.ServiceFactory.prototype.createTransactionService = function ()
{
	return new gc.gis.service.TransactionFeatureService(
		this._requestManager,
		this._requests.addFeatureUrl,
		this._requests.updateFeatureUrl,
		this._requests.deleteFeatureUrl
	);
};